import * as cookie from 'js-cookie';

import {
  COOKIE_DOMAIN,
  TRIAL_TYPE_PRO,
  TRIAL_TYPE_PRO_7DAYS,
  TRIAL_TYPE_PRO_2WEEKS,
  TRIAL_TYPE_PRO_1YEAR,
  TRIAL_TYPE_BUSINESS,
  TRIAL_TYPE_BUSINESS_7DAYS,
  TRIAL_TYPE_BUSINESS_2WEEKS,
  TRIAL_TYPE_BUSINESS_1YEAR,
} from '../modules/constants';

interface Query {
  ref?: string;
  [x: string]: any; // tslint:disable-line no-any
}

export const COOKIE_NAME = 'jimdoRefAffiliate';
const AFFILIATE_REGEX = /#ref=(a\d+)/;
const AFFILIATE_VALUE_REGEX = /^a\d+$/;

const TRIAL_TYPES = [
  TRIAL_TYPE_PRO,
  TRIAL_TYPE_PRO_7DAYS,
  TRIAL_TYPE_PRO_2WEEKS,
  TRIAL_TYPE_PRO_1YEAR,
  TRIAL_TYPE_BUSINESS,
  TRIAL_TYPE_BUSINESS_7DAYS,
  TRIAL_TYPE_BUSINESS_2WEEKS,
  TRIAL_TYPE_BUSINESS_1YEAR,
];

const storeAffiliate = (ref: string): void => {
  cookie.set(COOKIE_NAME, ref, {
    path: '/',
    domain: COOKIE_DOMAIN,
  });
};

export const isValidTrialType = (trial: string): boolean => {
  return TRIAL_TYPES.indexOf(trial) !== -1;
};

export default function affiliate(query: Query, hash: string): string {
  const hashResult = hash.match(AFFILIATE_REGEX);
  if (hashResult) {
    storeAffiliate(hashResult[1]);
    return hashResult[1];
  }

  if (typeof query.ref === 'string' && AFFILIATE_VALUE_REGEX.test(query.ref)) {
    storeAffiliate(query.ref);
    return query.ref;
  }

  return cookie.get(COOKIE_NAME);
}
